import React from "react";
import CertificateCard from "./CertificateCard";
import pythonhr from "../assets/certificates/pythonbasic_hr.png";
import javau from "../assets/certificates/java_udemy.png";
import pythonu from "../assets/certificates/python_udemy.png";

const Certificates = () => {
  return (
    <div id='certs' className='mt-4 text-white'>
      <h1 className='text-2xl font-bold'>Certifications</h1>
      <p className='font-light text-gray-400'>
        Here are some of my Certifications
      </p>

      <div className='grid grid-cols-1 md:grid-cols-3 justify-center mt-4 gap-5'>
        <CertificateCard
          name='Python (Basic)'
          img={pythonhr}
          issued='HackerRank'
          date='1 Sep, 2020'
        />
        <CertificateCard
          name='Java Programming: Complete Beginner to Advanced'
          img={javau}
          issued='Udemy'
          date='29 Dec, 2019'
        />
        <CertificateCard
          name='Python For Beginners Course In-Depth'
          img={pythonu}
          issued='Udemy'
          date='12 Jun, 2021'
        />
      </div>
    </div>
  );
};

export default Certificates;
